<template>
  <div class="oido-tabs">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      class="oido-tab"
      :class="{ active: modelValue === tab.value }"
      @click="$emit('update:modelValue', tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.oido-tabs {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
}

.oido-tab {
  flex: 1;
  padding: 0.6rem 0.8rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #666;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
}

.oido-tab:hover {
  color: #333;
}

.oido-tab.active {
  color: var(--ion-color-primary, #3880ff);
  border-bottom-color: var(--ion-color-primary, #3880ff);
}
</style>
